<template>
  <div
    class="d-flex flex-column px-5 py-3"
    style="border: 1px solid #24C4A3; border-radius: 40px"
    id="cumulative-info-panel"
  >
    <ul style="font-size: 16px; color: #999999">
      <li :class="{'item-filled': !isNullOrUndefined(doctorId)}">
        <div class="d-flex flex-row align-center justify-space-between">
          <span>{{ doctorName }}</span>
          <note-tooltip
            :note="doctorNote"
            :icon-size="18"
            :nudge-bottom="20"
            attach-id="cumulative-info-panel"
          />
        </div>
      </li>
      <li :class="{'item-filled': !isNullOrUndefined(filialId)}">
        {{ !isNullOrUndefined(filialId) ? filialName : 'Адрес' }}
      </li>
      <li :class="{'item-filled': !isNullOrUndefined(serviceId)}">
        {{ !isNullOrUndefined(serviceId) ? serviceName : 'Услуга' }}
      </li>
      <li :class="{'item-filled': !isNullOrUndefined(serviceId)}">
        {{ !isNullOrUndefined(serviceId) ? servicePrice : 'Стоимость приема' }}
      </li>
      <li :class="{'item-filled': !isNullOrUndefined(scheduleId)}">
        {{ !isNullOrUndefined(scheduleId) ? scheduleInfo : 'Дата и время' }}
      </li>
    </ul>
  </div>
</template>

<script>
import NoteTooltip from "@/components/tooltip/NoteTooltip.vue"
import {mapGetters} from "vuex"
import {isNullOrUndefined} from "@/plugins/object-helpers"

export default {
  name: "CumulativeInfoPanel",
  methods: {isNullOrUndefined},
  components: {
    NoteTooltip
  },
  computed: {
    ...mapGetters([
      'doctorId',
      'doctorName',
      'doctorNote',
      'filialId',
      'filialName',
      'serviceId',
      'serviceName',
      'servicePrice',
      'scheduleId',
      'scheduleInfo',
    ])
  }
}
</script>

<style scoped>
.item-filled {
  color: #2A3948
}
</style>